export enum FeatureFlagType {
  ClassicFeatures = 'ClassicFeatures',
  FreemiumSignup = 'FreemiumSignup'
}